import React from 'react'
import OrderHistory from '../../components/order/OrderHistory'

const OrderHistoryContainer = () => {
    return <OrderHistory />
}

export default OrderHistoryContainer
